<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title" translate>{{ title }}</h4>
  <button type="button" class="close" aria-label="Close" (click)="close()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <div class="col-12">
    <div class="form-group">
      <label for="value" class="control-label" translate>{{ label }}</label>
      @if (isNumberInput) {
        <input
          class="form-control"
          type="number"
          name="value"
          id="value"
          [(ngModel)]="value"
          onkeypress="return /[0-9]/i.test(event.key)"
          ngbAutofocus
        />
      } @else if (isTextArea) {
        <textarea
          class="form-control"
          type="text"
          name="value"
          id="value"
          [(ngModel)]="value"
          ngbAutofocus
        ></textarea>
      } @else {
        <input
          class="form-control"
          type="text"
          name="value"
          id="value"
          [(ngModel)]="value"
          ngbAutofocus
        />
      }
    </div>
  </div>
</div>

<div class="modal-footer">
  <div class="row w-100">
    <div class="col-12">
      <div class="btn-group btn-group-justified w-100">
        <button class="btn btn-sm btn-outline-secondary btn-default" (click)="close()" translate>CANCEL</button>
        <button class="btn btn-sm btn-primary btn-default" (click)="save()" translate>SAVE</button>
      </div>
    </div>
  </div>
</div>
